import { AuthCallback, RequireAuth, HostedLogin } from '@psyomics/ui-common';
import { BackgroundLayout, GenericError } from '@psyomics/ui-components';
import { Route, Routes, Navigate } from 'react-router-dom';

import App from './app/app';
import { LoggedOut } from './app/routes/logged-out/logged-out';
import { LandingPage } from './landing-page';
import { SecureLayout } from './secure-layout';

const whitelistPaths = ['/account/:organisation/login'];

const getLoginRoute = ({ organisation }: { organisation?: string }) =>
  organisation ? `/account/${organisation}/login` : null;

const AuthRoutes = () => (
  <Routes>
    <Route Component={LoggedOut} path="/logged-out" />
    <Route Component={LandingPage} path="/" />
    <Route element={<AuthCallback />} path="/auth/callback" />
    <Route
      element={<RequireAuth getLoginRoute={getLoginRoute} whitelistedPaths={whitelistPaths} />}
      path="/account/:organisation"
    >
      <Route element={<HostedLogin />} path="login" />
      <Route element={<SecureLayout />}>
        <Route element={<Navigate replace to="home" />} index />
        <Route Component={BackgroundLayout}>
          <Route element={<App />} path="home/*" />
        </Route>
      </Route>
    </Route>
    <Route element={<GenericError titleKey="common.errors.notFound" />} path="/*"></Route>
  </Routes>
);

export { AuthRoutes, getLoginRoute };
